import { nanoid } from "nanoid";

export const generateId = () => {
  return nanoid();
};
